import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storeList: {
    addStoreListPage: 1,
    storeListPage: 1,
    addStoreListSearch: '',
    storeListPageSearch: '',
  },
  registerForm: {
    code: '',
    tel: '',
    space: [] /* [{floor: String, name: String, filePath: String}] */,
    addedSpace: [],
  },
  spaceRegisterForm: {
    floor: '1F',
    name: '',
    selectedFile: null,
  },
  error: null,
  loading: [],
};

export const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    changeProp: (state, { payload: { obj, key, value } }) => {
      if (obj) {
        state[obj][key] = value;
      } else {
        state[key] = value;
      }
    },
    initialize: (state, { payload }) => {
      state[payload] = initialState[payload];
    },
    setOriginalStore: ({ registerForm }, { payload: { code, tel, space } }) => {
      registerForm.code = code;
      registerForm.tel = tel;
      registerForm.space = space;
    },
  },
});

export const { changeProp, initialize, setOriginalStore } = storeSlice.actions;

export default storeSlice.reducer;
